module.exports = __webpack_public_path__ + "img/web-p2-c1.59af484d.svg";